import React from 'react';

interface WorkflowsEmptyStateProps {
  type: 'empty' | 'error';
  onRetry?: () => void;
}

export function WorkflowsEmptyState({ type, onRetry }: WorkflowsEmptyStateProps) {
  if (type === 'error') {
    return (
      <div style={styles.container}>
        <span style={styles.icon}>⚠️</span>
        <p style={styles.message}>Something went wrong loading workflows.</p>
        {onRetry && (
          <button style={styles.retryButton} onClick={onRetry}>
            Retry
          </button>
        )}
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <span style={styles.icon}>📋</span>
      <p style={styles.message}>No workflows yet</p>
      <p style={styles.prompt}>Create your first workflow to get started.</p>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px',
    textAlign: 'center',
  },
  icon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  message: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#333',
    margin: '0 0 8px 0',
  },
  prompt: {
    fontSize: '14px',
    color: '#666',
    margin: 0,
  },
  retryButton: {
    marginTop: '16px',
    padding: '8px 20px',
    fontSize: '14px',
    fontWeight: 600,
    color: '#fff',
    backgroundColor: '#1a6b3c',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  },
};
